export default "__VITE_ASSET__BkONOCfV__"